import React from 'react';
import {_GPY,__GPYPost} from '../../../env.js'

import moment from 'moment';
import 'moment/locale/de';
import OBS from '../../OBS.js'

class ScoreboardDefaultHead extends  React.Component {

	constructor(props) {
		super(props);
		this.state = {
					doStore: false,
					keyConfMode:false,
					timeConfMode:false,
		};
	}

  render () {
    return (<div>

      {this.props.beta?
        <><span className="text-danger"><span className="glyphicon glyphicon-wrench" aria-hidden="true"></span> Beta Version</span><button className="btn btn-link btn-sm" onClick={()=>{ this.props.scoreboard.props.setGameType("BugReport")}}>Report bugs or wishes</button></>:""}

      <div className="row">
        <div className="col-6 text-left">
     <button type="button" onClick={()=>{this.props.scoreboard.doChangeValue({},"OBS","toggleOBSPanel");}} className={this.props.scoreboard.state.components.OBS!==undefined&&this.props.scoreboard.state.components.OBS.state.showOBSPanel===true?"btn btn-sm btn-warning":"btn btn-sm btn-outline-secondary"}><img style={{verticalAlign: "baseline", maxWidth : '13px', maxHeight : '13px'}} src={_GPY.resource("images/obs_black.png")} className="img-fluid" alt=""/></button>

		 <div className="btn-group pl-1" role="group" aria-label="menuicons">
				  <button type="button" onClick={()=>{
						this.setState({keyConfMode:!this.state.keyConfMode,timeConfMode:false,doStore:true},()=>{
							var tbs = this.props.scoreboard.state.toggleButtons;
							Object.keys(tbs).forEach((key, i) => {
								  tbs[key].toggleKeyCodeEditMode(this.state.keyConfMode);
							});
						});
					}} className={this.state.keyConfMode?"btn btn-sm btn-warning":"btn btn-sm btn-outline-secondary"}><span className="glyphicon glyphicon-cog" aria-hidden="true"></span></button>

					<button type="button" onClick={()=>{
						this.setState({timeConfMode:!this.state.timeConfMode,keyConfMode:false,doStore:true},()=>{
							var tbs = this.props.scoreboard.state.toggleButtons;
							Object.keys(tbs).forEach((key, i) => {
								  tbs[key].toggleAutoexpirytimeEditMode(this.state.timeConfMode);
							});
						});
					}} className={this.state.timeConfMode?"btn btn-sm btn-warning":"btn btn-sm btn-outline-secondary"}><span className="glyphicon glyphicon-time" aria-hidden="true"></span></button>
    </div>

{_GPY.uiStates.userLvl >= _GPY.USER_EXPERT ?
		<div className="btn-group pl-1" role="group" aria-label="adminmenuicons">
				<button type="button" onClick={()=>{
					var tbs = this.props.scoreboard.state.toggleButtons;
					var list = [];
					Object.keys(tbs).forEach((key, i) => {
							list.push(key);
					});
					list.sort();
					_GPY.toggleButtonList = list;
					console.log("toggleButtonList",	_GPY.toggleButtonList);
				}} className="btn btn-sm btn-outline-secondary"><span className="glyphicon glyphicon-copy" aria-hidden="true"></span></button>
  	</div>
:""}

{this.state.doStore?
	<div className="btn-group pl-2" role="group" aria-label="discardorstore">
					<button type="button" onClick={()=>{
						var tbs = this.props.scoreboard.state.toggleButtons;
						var conf = {};
						Object.keys(tbs).forEach((key, i) => {
								tbs[key].disableEditMode();
								conf[key] = tbs[key].state.conf;
						})
						__GPYPost('storeUserConfig',{name:"buttons_"+this.props.scoreboard.getName(),data:JSON.stringify(conf)},()=>{
							this.setState({doStore:false});
						});
					}} className="btn btn-sm btn-success"><span className="glyphicon glyphicon-save" aria-hidden="true"></span> Store</button>

					<button type="button" onClick={()=>{
							var tbs = this.props.scoreboard.state.toggleButtons;
							Object.keys(tbs).forEach((key, i) => {
								tbs[key].disableEditMode();
							});
						  this.props.scoreboard.loadUserConfig();
							this.setState({doStore:false,timeConfMode:false,keyConfMode:false});
					}} className="btn btn-sm btn-secondary"><span className="glyphicon glyphicon-ban-circle" aria-hidden="true"></span> Discard changes</button>
	</div>
	:""}

        </div>
    </div>
    <OBS className="mb-2" scoreboard={this.props.scoreboard}/>
  </div>)
  }
}
export default ScoreboardDefaultHead;
